import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/styles/adminlogin.css";

function AdminLogin(){

const navigate = useNavigate();
const [username,setUsername] = useState("");
const [password,setPassword] = useState("");

const handleLogin = (e) =>{
e.preventDefault();

if(username === "admin" && password === "1234"){
navigate("/dashboard");
}else{
alert("Invalid Admin Login");
}

};

return (

    <div className="login-container">
    
    <div className="login-card">
    
    <h2>Admin Login</h2>
    
    <form onSubmit={handleLogin}>
    
    <input
    type="text"
    placeholder="Admin Username"
    value={username}
    onChange={(e)=>setUsername(e.target.value)}
    />
    
    <input
    type="password"
    placeholder="Password"
    value={password}
    onChange={(e)=>setPassword(e.target.value)}
    />
    
    <button type="submit">Login</button>
    
    </form>
    
    </div>
    
    </div>
    
    );

}

export default AdminLogin;